/* pack-builder-patch.js */

(function() {

  // ============================================
  // BOTÓN "SEGUIR COMPRANDO" EN EL CARRITO
  // ============================================
  function patchContinueShoppingButton() {
    if (window.location.pathname !== '/cart') return;

    var continueBtn = null;
    var allLinks = document.querySelectorAll('a');
    for (var i = 0; i < allLinks.length; i++) {
      var text = allLinks[i].textContent.toLowerCase().trim();
      if (text.includes('seguir comprando') || text.includes('continue shopping')) {
        continueBtn = allLinks[i];
        break;
      }
    }
    if (!continueBtn) return;

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var hasPack16 = false;
        var hasPack8 = false;
        cart.items.forEach(function(item) {
          var packSize = item.properties && item.properties['_pack_size'];
          if (packSize == 16) hasPack16 = true;
          if (packSize == 8) hasPack8 = true;
        });
        if (hasPack16) {
          continueBtn.href = '/pages/pack-de-16-configurador';
        } else if (hasPack8) {
          continueBtn.href = '/pages/pack-de-8';
        }
      })
      .catch(function(e) { console.warn('Error leyendo carrito:', e); });
  }

  // Detectar si estamos en ficha de producto
  function isProductPage() {
    try {
      var scripts = document.querySelectorAll('script[type="application/json"]');
      for (var i = 0; i < scripts.length; i++) {
        var data = JSON.parse(scripts[i].textContent);
        if (data.pageType === 'product') return true;
      }
    } catch(e) {}
    return false;
  }

  // ============================================
  // OCULTAR POPUP MINIMAL
  // ============================================
  function hidePopupMinimal() {
    document.querySelectorAll('[id*="popup-minimal"]').forEach(function(el) {
      el.style.setProperty('display', 'none', 'important');
    });
  }

  // ============================================
  // BADGE AGOTADO EN FICHA DE PRODUCTO
  // ============================================
  function injectSoldOutBadge() {
    if (!isProductPage()) return;
    if (document.getElementById('lupuloa-soldout-badge')) return;
    var pack8btn = document.querySelector('a[href*="pack-de-8"]');
    if (!pack8btn) return;
    var isSoldOut = false;
    try {
      var allScripts = document.querySelectorAll('script');
      for (var i = 0; i < allScripts.length; i++) {
        var text = allScripts[i].textContent;
        if (text.includes('"available":false') && text.includes('"variants"')) {
          isSoldOut = true;
          break;
        }
      }
    } catch(e) {}
    if (!isSoldOut) return;
    var badge = document.createElement('div');
    badge.id = 'lupuloa-soldout-badge';
    badge.innerHTML = '⚠️ <strong>Agotado temporalmente</strong> — Puedes seguir añadiéndola a tu pack cuando vuelva a estar disponible.';
    badge.style.cssText = 'background:#fff3cd;border:1px solid #ffc107;color:#856404;padding:12px 16px;border-radius:8px;font-size:0.9rem;margin-bottom:16px;line-height:1.5;text-align:left;width:100%;box-sizing:border-box;';
    pack8btn.parentNode.insertBefore(badge, pack8btn);
  }

  // ============================================
  // REDIRIGIR ATC EN TARJETAS (no en ficha)
  // ============================================
  document.addEventListener('click', function(e) {
    if (isProductPage()) return;
    var btn = e.target.closest('button[name="add"]');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = '/pages/pack-de-16-configurador';
  }, true);

  function patchButtonText() {
    if (isProductPage()) return;
    document.querySelectorAll('button[name="add"]:not([data-patched])').forEach(function(btn) {
      btn.dataset.patched = 'true';
      var span = btn.querySelector('.button-text');
      if (span && (span.textContent.includes('carrito') || span.textContent.includes('cart'))) {
        span.textContent = 'Diseña tu Pack de 16';
      }
    });
  }

  // ============================================
  // BADGE MENÚ PACK 16
  // ============================================
  function patchMenuBadge() {
    document.querySelectorAll('a[href*="pack-de-16"]').forEach(function(link) {
      if (link.querySelector('.menu-pack16-badge')) return;
      var badge = document.createElement('span');
      badge.className = 'menu-pack16-badge';
      badge.textContent = '5% dto.';
      link.appendChild(badge);
      link.style.whiteSpace = 'nowrap';
    });
  }

  function runAll() {
    hidePopupMinimal();
    injectSoldOutBadge();
    patchButtonText();
    patchMenuBadge();
    patchContinueShoppingButton();
  }

  hidePopupMinimal();
  setTimeout(runAll, 300);
  setTimeout(runAll, 800);
  setTimeout(runAll, 2000);

  document.addEventListener('DOMContentLoaded', function() {
    runAll();
    var observer = new MutationObserver(function() {
      patchButtonText();
      hidePopupMinimal();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });

})();
